<template>
    <hts-slide-over
        :show="props.show"
        color="main"
        :width-size="props.sizeSlideOver"
        :custom="['header', 'footer']"
        :rules="form.rulesBranch"
        :submit="handleSubmitFormAddBranch"
        :title="$t('labels.addCompanyBranch')"
        :undo-enable="true"
        @close="closeOverSide"
        @undo="undo()">
        <hts-card :title="$t('labels.generalInformation')">
            <div
                class="grid gap-4"
                :class="columnClass">
                <hts-form-input
                    v-model="dataFormAddBranch.name"
                    :label="$t('labels.branchName')"
                    :required="true"
                    :color="props.color"
                    prop="name"
                    name="name" />
                <hts-form-input
                    v-model="dataFormAddBranch.taxNumber"
                    :label="$t('labels.taxNumber')"
                    :required="true"
                    :color="props.color"
                    prop="taxNumber"
                    name="taxNumber" />
                <hts-form-input
                    v-model="dataFormAddBranch.website"
                    :label="$t('labels.website')"
                    :color="props.color"
                    :required="true"
                    prop="website"
                    name="website" />
                <hts-form-input
                    v-model="dataFormAddBranch.address"
                    :label="$t('labels.address')"
                    :color="props.color"
                    :required="true"
                    prop="address"
                    name="address" />
            </div>
        </hts-card>
    </hts-slide-over>
</template>

<script setup lang="ts">
import form from './imports/form'

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
    required: true
  },
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: String,
    default: 'small'
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 1
  },
  listTypeSupplies: {
    type: Object
  }
})

const emits = defineEmits(['close', 'actionAddBranch', 'refreshTables'])

const closeOverSide = () => {
  emits('close')
}
const dataFormAddBranch = reactive({ ...form.initBranch })

const undo = () => {
  Object.assign(dataFormAddBranch, { ...form.initBranch })
}

const handleSubmitFormAddBranch = () => {
  const api = {
    url: '/company/branch/create-branch',
    method: 'post'
  }

  $api(api, { body: { ...dataFormAddBranch } })
    .then((data) => {
      const resData: any = data?.data.value
      const resError: any = data?.error

      if (resData) {
        if (resData.success) {
          const newbranch = resData.meta
          Object.assign(dataFormAddBranch, { ...form.initBranch })
          emits('actionAddBranch', newbranch)
          process.client && $toast().success($t('labels.done'))
          emits('close')
          emits('refreshTables')
        }
      } else if (resError.value.data === undefined) {
        process.client && $toast().error($t('labels.canNotConnectServer'))
      } else {
        process.client && $toast().error(resError.value.data.errors[0].msg)
      }
    })
    .catch(() => {
      process.client && $toast().error($t('labels.canNotConnectServer'))
    })
}

const columnClass = computed(() => {
  if ($lodash.inRange(props.column, 1, 12)) {
    return `grid-cols-${props.column}`
  }

  return 'grid-cols-1'
})
</script>
